export const FontSpacingIcon = () => {
    return (
        <svg
            width={24}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="fill-black dark:fill-white"
        >
            <path d="M22.333 12.5H7.667c-.368 0-.667-.336-.667-.75s.299-.75.667-.75h14.666c.368 0 .667.336.667.75s-.299.75-.667.75ZM22.333 5.5H7.667C7.299 5.5 7 5.164 7 4.75S7.299 4 7.667 4h14.666c.368 0 .667.336.667.75s-.299.75-.667.75ZM22.333 19.5H7.667c-.368 0-.667-.336-.667-.75s.299-.75.667-.75h14.666c.368 0 .667.336.667.75s-.299.75-.667.75ZM1.178 7.21a.5.5 0 0 1-.054-.705l1.996-2.33a.5.5 0 0 1 .76 0l1.998 2.33a.5.5 0 0 1-.758.652L4.001 5.852v12.3l1.12-1.306a.5.5 0 1 1 .759.65l-1.998 2.33a.5.5 0 0 1-.758 0l-2-2.33a.5.5 0 1 1 .758-.65L3 18.149V5.85L1.881 7.157a.5.5 0 0 1-.704.054Z" />
        </svg>
    );
};
